// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3KvSj","col":"Table_col__eo890","fulfillmentStatus":"Table_fulfillmentStatus__1LQLX","emailCol":"Table_emailCol__2TjpF"};